import { makeAutoObservable, observable, toJS  } from "mobx";
import { WRFMSettingService } from "../services/wrfmsettingservice";

class WRFMSettingStore {
  constructor() {
    makeAutoObservable(this);
  }

  flowstations = observable.map({});
  fields = observable.map({});
  wells = observable.map({});
  levels = observable.map({});
  flowstationfields = observable.map({});
  operatingCapacities = observable.map({});
  disableCommand = true;
  action = "Add";
  selRow = {};
  isLoading = false;
  isSaving = false;
  selMapping = {
    flowstationId: null,
    flowstationName: "",
    fieldId: null,
    fieldName: "",
  };
  selCapacity = {
    flowstationId: null,
    flowstationName: "",
    fieldId: null,
    fieldName: "",
  };
  showMappingDialog = false;
  showFlowsationCapcityDialog = false;
  async loadFlowStations() {
    try {
      this.isLoading = true;
      const flowstations = await WRFMSettingService.loadFlowStations();
      this.flowstations.clear();
      flowstations.forEach((f) => {
        this.flowstations.set(f.flowstationId, f);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async createFlowstation(flowstation) {
    try {
      this.isSaving = true;
      const retVal = await WRFMSettingService.createFlowstation(flowstation);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async loadFields() {
    try {
      this.isLoading = true;
      const fields = await WRFMSettingService.loadFields();

      this.fields.clear();
      fields.forEach((f) => {
        this.fields.set(f.fieldId, f);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async createField(field) {
    try {
      this.isSaving = true;
      const retVal = await WRFMSettingService.createField(field);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async loadWells() {
    try {
      this.isLoading = true;
      const wells = await WRFMSettingService.loadWells();

      this.wells.clear();
      wells.forEach((f) => {
        this.wells.set(f.wellId, f);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async createWell(well) {
    try {
      this.isSaving = true;
      const retVal = await WRFMSettingService.createWell(well);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async loadLevels() {
    try {
      this.isLoading = true;
      const levels = await WRFMSettingService.loadLevels();

      this.levels.clear();
      levels.forEach((l) => {
        this.levels.set(l.levelId, l);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async createLevel(level) {
    try {
      this.isSaving = true;
      const retVal = await WRFMSettingService.createLevel(level);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async loadMapping() {
    try {
      this.isLoading = true;
      const mappings = await WRFMSettingService.loadMappings();
      console.log("map", mappings);
      this.flowstationfields.clear();
      mappings.forEach((f) => {
        this.flowstationfields.set(f.flowstationFieldId, f);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async createMapping() {
    try {
      this.isSaving = true;
      const mapping = toJS(this.selMapping);
      const retVal = await WRFMSettingService.createMapping(mapping);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }

  async loadOperatingCapacity() {
    try {
      this.isLoading = true;
      const mappings = await WRFMSettingService.loadOperatingCapacity();

      this.operatingCapacities.clear();
      mappings.forEach((f) => {
        this.operatingCapacities.set(f.flowstationCapacityId, f);
      });
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async createCapcity() {
    try {
      this.isSaving = true;
      const capacity = toJS(this.selCapacity);
      const retVal = await WRFMSettingService.createCapacity(capacity);
      return retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
}



const wrfmSettingStore = new WRFMSettingStore();

export default wrfmSettingStore;

